import { get } from 'lodash';
import SHOW_LAB_VENDORS from '../queries/vendors/show-lab-vendors';

function getLabVendors(memberId, client) {
  return client.query({
    query:       SHOW_LAB_VENDORS,
    fetchPolicy: 'network-only',
    variables:   { id: memberId }
  }).then(response => get(response, 'data.member'));
}

export default getLabVendors;
